module.exports = __webpack_public_path__ + "media/scratch_sound.47caf43b.mp3";